import { Children, cloneElement, Fragment, isValidElement, type ReactNode } from "react";

/**
 * `Children.toArray` with Fragments opened. Charts find their series by `child.type`, and `toArray`
 * returns a Fragment as one element of type `Fragment`, so series grouped in `<>…</>` were dropped.
 */
export function flattenChartChildren(children: ReactNode, keyPrefix = ""): ReactNode[] {
  return Children.toArray(children).flatMap((child) => {
    if (isValidElement<{ children?: ReactNode }>(child) && child.type === Fragment) {
      return flattenChartChildren(child.props.children, `${keyPrefix}${String(child.key)}`);
    }
    return keyPrefix && isValidElement(child)
      ? [cloneElement(child, { key: `${keyPrefix}${String(child.key)}` })]
      : [child];
  });
}
